module.exports = __webpack_public_path__ + "static/img/xzicon02.bc952f19.png";